import type { ResponseWithType } from './types';
import type { Statistics, StatisticsRest } from './types/statistics';

const statistics = ({ data }: ResponseWithType<StatisticsRest>): Statistics => {
  return {
    ...data,
    __typename: 'Statistics',
  };
};

export default statistics;
